import React from "react";
import { Skeleton } from "@mui/material";

const GroupChatSkeleton = () => {
  return (
    <div className="tw-w-full tw-bg-[#FFFFFF] tw-border tw-border-[#E9EAEB] tw-rounded-lg">
      {/* Header Skeleton */}
      <div className="tw-border-b tw-border-[#CBD5E1]">
        <div className="tw-p-4 tw-mx-4 tw-flex tw-items-start tw-justify-between">
          <div className="tw-flex tw-items-center tw-space-x-3">
            {/* Avatar Skeleton */}
            <Skeleton
              variant="circular"
              width={40}
              height={40}
              className="tw-bg-gray-200"
            />
            <div>
              {/* Name Skeleton */}
              <Skeleton
                variant="text"
                width={128}
                height={24}
                className="tw-mb-2 tw-bg-gray-200"
              />
              {/* Members count Skeleton */}
              <Skeleton
                variant="text"
                width={96}
                height={20}
                className="tw-bg-gray-200"
              />
            </div>
          </div>
          {/* Terminate Button Skeleton */}
          <Skeleton
            variant="rectangular"
            width={144}
            height={48}
            className="tw-rounded-lg tw-bg-gray-200"
          />
        </div>
      </div>

      {/* Chat Area Skeleton */}
      <div className="tw-flex tw-justify-center tw-items-center tw-h-[calc(100vh-345px)] tw-overflow-y-auto tw-overflow-x-hidden">
        <div className="tw-bg-[#F8FAFC] tw-rounded-xl tw-px-5 tw-py-4 tw-w-[337px]">
          {/* Welcome Message Skeleton */}
          <Skeleton
            variant="text"
            width="100%"
            height={24}
            className="tw-mb-4 tw-bg-gray-200"
          />
          <Skeleton
            variant="text"
            width="80%"
            height={24}
            className="tw-mb-4 tw-mx-auto tw-bg-gray-200"
          />
          {/* Add Member Button Skeleton */}
          <Skeleton
            variant="rectangular"
            width={128}
            height={40}
            className="tw-rounded-lg tw-mx-auto tw-bg-gray-200"
          />
        </div>
      </div>

      {/* Input Area Skeleton */}
      <div className="tw-px-8 tw-py-4">
        <div className="tw-relative tw-flex tw-items-center">
          {/* Input Box Skeleton */}
          <Skeleton
            variant="rectangular"
            width="100%"
            height={48}
            className="tw-rounded-lg tw-bg-gray-200"
          />
          {/* Send Button Skeleton */}
          <div className="tw-absolute tw-right-2">
            <Skeleton
              variant="circular"
              width={32}
              height={32}
              className="tw-bg-gray-200"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default GroupChatSkeleton;
